/**
 * Language
 */
export class Language {
  /**
   * Language
   */
  languageId: string;

  /**
   * Name
   */
  name: string;

  /**
   * Treatment M
   */
  treatmentM: string;

  /**
   * Treatment F
   */
  treatmentF: string;

  /**
   * ISO code
   */
  isoCode: string;

  /**
   * Constructor
   *
   * @param language Language
   * @param name Name
   * @param treatmentM Male Treatment
   * @param treatmentF: Female Treatment
   * @param isocode ISO code
   */
  constructor(languageId?: string, name?: string, treatmentM?: string, treatmentF?: string, isoCode?: string) {
    this.languageId = languageId;
    this.name = name;
    this.treatmentM = treatmentM;
    this.treatmentF = treatmentF;
    this.isoCode = isoCode;
  }

  /**
   * Create from json
   *
   * @param json Json with data
   *
   * @return self
   */
  static createFromJson(json: object): Language {
    const self = new this();

    Object.keys(self).forEach((key) => {
      self[key] = json[key];
    });

    return self;
  }
}
